type HeaderProviderFn = () => Record<string, string> | Promise<Record<string, string>>;
type OnUnauthorizedFn = () => Promise<Record<string, string> | null>;
type OnErrorFn = (error: Error) => void;

export interface IClientConfig {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  headerProvider?: HeaderProviderFn;
  onUnauthorized?: OnUnauthorizedFn;
  onError?: OnErrorFn;
  timeout?: number;
}

export function createClientConfig({
  baseUrl,
  defaultHeaders = {
    'Content-Type': 'application/json',
  },
  headerProvider,
  onUnauthorized,
  onError,
  timeout = 30000,
}: {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  headerProvider?: HeaderProviderFn;
  onUnauthorized?: OnUnauthorizedFn;
  onError?: OnErrorFn;
  timeout?: number;
}): IClientConfig {
  return {
    baseUrl,
    defaultHeaders,
    headerProvider,
    onUnauthorized,
    onError,
    timeout,
  };
}
